// extracted by mini-css-extract-plugin
module.exports = {"modal":"Modal_modal__wS21h","container":"Modal_container__ZWA6s","close":"Modal_close__3Fiuw","icon":"Modal_icon__1C6P_","content":"Modal_content__2zaTX"};